if (window.Swiper) {
  if (document.querySelector(".slider_text_review") && !document.querySelector(".slider_text_review.swiper-initialized")) {
    new Swiper(".slider_text_review", {
      loop: document.querySelectorAll(".slider_text_review .swiper-slide").length > 3,
      spaceBetween: 5,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }

  if (document.querySelector(".slider_text_video") && !document.querySelector(".slider_text_video.swiper-initialized")) {
    new Swiper(".slider_text_video", {
      loop: document.querySelectorAll(".slider_text_video .swiper-slide").length > 4,
      spaceBetween: 4,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: '.slider__pagination',
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }
}
